module.exports = __webpack_public_path__ + "img/product_13.d30d76a.jpg";